module.exports = __webpack_public_path__ + "static/media/typec.d82d905d.jpg";